import React, { useEffect, useRef, useState } from "react";
import { X } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { buildWaLink } from "../lib/api";

// Channel handles — update these as the user provides real ones
const TELEGRAM_USERNAME = "ceotravelbatam"; // https://t.me/<username>
const LINE_LINK = "https://line.me/ti/p/nLGRbyBSqH";
const WECHAT_ID = "ceotravel88"; // aktif — klik untuk salin

const WAIcon = (props) => (
  <svg viewBox="0 0 32 32" fill="currentColor" {...props}>
    <path d="M16.001 3C9.373 3 4 8.373 4 15c0 2.385.703 4.605 1.91 6.473L4 29l7.728-1.873A11.94 11.94 0 0016.001 27C22.628 27 28 21.627 28 15S22.628 3 16.001 3zm0 21.6c-1.71 0-3.355-.45-4.79-1.297l-.343-.205-4.582 1.11 1.12-4.467-.224-.355A9.547 9.547 0 016.4 15c0-5.292 4.31-9.6 9.6-9.6 5.292 0 9.6 4.308 9.6 9.6 0 5.293-4.308 9.6-9.6 9.6zm5.494-7.181c-.3-.15-1.776-.876-2.052-.976-.275-.1-.476-.15-.676.15-.2.301-.776.976-.951 1.176-.175.2-.351.226-.65.076-.3-.15-1.266-.466-2.412-1.486-.892-.796-1.494-1.78-1.668-2.08-.176-.302-.02-.464.13-.613.135-.135.301-.351.451-.527.15-.176.2-.3.301-.5.1-.2.05-.376-.025-.526-.075-.15-.676-1.63-.926-2.232-.244-.586-.494-.506-.676-.515l-.575-.011c-.2 0-.526.075-.801.376-.276.301-1.05 1.025-1.05 2.5 0 1.476 1.075 2.9 1.224 3.1.15.2 2.117 3.232 5.13 4.532.717.31 1.276.495 1.713.633.72.229 1.376.197 1.894.119.578-.087 1.776-.726 2.026-1.426.25-.7.25-1.301.175-1.426-.075-.125-.275-.2-.575-.35z" />
  </svg>
);

const TelegramIcon = (props) => (
  <svg viewBox="0 0 32 32" fill="currentColor" {...props}>
    <path d="M16 0C7.163 0 0 7.163 0 16s7.163 16 16 16 16-7.163 16-16S24.837 0 16 0zm7.694 11.044l-2.572 12.13c-.194.866-.706 1.08-1.43.673l-3.95-2.911-1.905 1.834c-.211.211-.388.388-.793.388l.283-4.01 7.305-6.6c.318-.282-.069-.439-.493-.158l-9.03 5.685-3.89-1.214c-.846-.265-.864-.846.176-1.253l15.213-5.866c.706-.265 1.324.158 1.086 1.253z" />
  </svg>
);

const LineIcon = (props) => (
  <svg viewBox="0 0 32 32" fill="currentColor" {...props}>
    <path d="M16 3C8.268 3 2 8.084 2 14.358c0 5.622 4.97 10.331 11.685 11.224.456.098 1.075.302 1.232.694.142.356.093.913.046 1.273l-.2 1.196c-.06.355-.282 1.391 1.22.758 1.503-.633 8.107-4.775 11.062-8.176C29.064 19.106 30 16.852 30 14.358 30 8.084 23.732 3 16 3zM10.205 17.788H7.4c-.405 0-.736-.331-.736-.736v-5.612c0-.404.331-.735.736-.735.405 0 .736.331.736.735v4.876h2.069c.405 0 .736.331.736.736s-.331.736-.736.736zm2.39-.736c0 .405-.331.736-.736.736s-.736-.331-.736-.736V11.44c0-.404.331-.735.736-.735s.736.331.736.735v5.612zm6.736 0c0 .317-.204.6-.503.706-.077.025-.156.03-.234.03-.225 0-.45-.103-.59-.292l-2.876-3.917v3.473c0 .405-.331.736-.736.736s-.736-.331-.736-.736V11.44c0-.317.204-.6.503-.706.077-.025.155-.03.234-.03.225 0 .45.103.59.292l2.876 3.916V11.44c0-.404.331-.735.736-.735s.736.331.736.735v5.612zm4.505-3.539c.405 0 .736.331.736.736s-.331.736-.736.736h-2.07v1.331h2.07c.405 0 .736.331.736.736s-.331.736-.736.736h-2.806c-.405 0-.736-.331-.736-.736V11.44c0-.405.331-.736.736-.736h2.806c.405 0 .736.331.736.736s-.331.736-.736.736h-2.07v1.331h2.07z" />
  </svg>
);

const WeChatIcon = (props) => (
  <svg viewBox="0 0 32 32" fill="currentColor" {...props}>
    <path d="M11.5 5C5.7 5 1 8.8 1 13.5c0 2.6 1.5 4.9 3.8 6.5l-.9 2.9 3.4-1.7c1.2.3 2.4.5 3.7.5h.4c-.2-.6-.3-1.3-.3-2 0-4.4 4-7.9 9-7.9.4 0 .8 0 1.2.1C20.5 7.7 16.4 5 11.5 5zm-4 3.5c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5S6 10.8 6 10s.7-1.5 1.5-1.5zm8 0c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5S14 10.8 14 10s.7-1.5 1.5-1.5zM21 13c-4.4 0-8 3.1-8 7s3.6 7 8 7c.9 0 1.8-.1 2.7-.4l2.7 1.4-.8-2.3c1.9-1.3 3.2-3.4 3.2-5.7 0-3.9-3.4-7-7.8-7zm-2.5 2.5c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1zm5 0c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1z" />
  </svg>
);

const channelLabels = {
  id: { title: "Chat dengan kami", sub: "Pilih channel favorit Anda", wa: "WhatsApp", tg: "Telegram", line: "LINE", wc: "WeChat", soon: "Segera", copied: "ID WeChat disalin!" },
  en: { title: "Chat with us", sub: "Pick your favourite channel", wa: "WhatsApp", tg: "Telegram", line: "LINE", wc: "WeChat", soon: "Soon", copied: "WeChat ID copied!" },
  zh: { title: "联系我们", sub: "选择您喜欢的方式", wa: "WhatsApp", tg: "Telegram", line: "LINE", wc: "微信", soon: "即将开放", copied: "微信号已复制！" },
  ja: { title: "チャットで連絡", sub: "お好きなチャネルを選択", wa: "WhatsApp", tg: "Telegram", line: "LINE", wc: "WeChat", soon: "近日公開", copied: "WeChat ID コピー済み" },
  ko: { title: "채팅으로 문의", sub: "선호하는 채널을 선택하세요", wa: "WhatsApp", tg: "Telegram", line: "LINE", wc: "WeChat", soon: "출시 예정", copied: "WeChat ID 복사됨" },
  vi: { title: "Chat với chúng tôi", sub: "Chọn kênh yêu thích", wa: "WhatsApp", tg: "Telegram", line: "LINE", wc: "WeChat", soon: "Sắp ra mắt", copied: "Đã copy WeChat ID!" },
  th: { title: "แชทกับเรา", sub: "เลือกช่องทางที่คุณชอบ", wa: "WhatsApp", tg: "Telegram", line: "LINE", wc: "WeChat", soon: "เร็วๆ นี้", copied: "คัดลอก WeChat ID แล้ว!" },
};

export const FloatingChat = () => {
  const { t, lang } = useLang();
  const [open, setOpen] = useState(false);
  const [wechatCopied, setWechatCopied] = useState(false);
  const panelRef = useRef(null);
  const L = channelLabels[lang] || channelLabels.en;

  useEffect(() => {
    const onClick = (e) => {
      if (open && panelRef.current && !panelRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    document.addEventListener("mousedown", onClick);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onClick);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);

  const onWeChat = (e) => {
    e.preventDefault();
    if (!WECHAT_ID) return;
    navigator.clipboard?.writeText(WECHAT_ID).then(() => {
      setWechatCopied(true);
      setTimeout(() => setWechatCopied(false), 2500);
    });
  };

  const channels = [
    { key: "wa", label: L.wa, color: "#25D366", icon: WAIcon, href: buildWaLink(t.waMessages.consult), enabled: true },
    { key: "tg", label: L.tg, color: "#229ED9", icon: TelegramIcon, href: `https://t.me/${TELEGRAM_USERNAME}`, enabled: true },
    { key: "line", label: L.line, color: "#06C755", icon: LineIcon, href: LINE_LINK, enabled: true },
    { key: "wc", label: L.wc, color: "#07C160", icon: WeChatIcon, href: WECHAT_ID ? "#" : null, enabled: !!WECHAT_ID, onClick: onWeChat },
  ];

  return (
    <div ref={panelRef} className="fixed bottom-6 right-6 z-40 md:bottom-8 md:right-8">
      {/* Channel options panel */}
      {open && (
        <div
          data-testid="floating-chat-panel"
          className="absolute bottom-[calc(100%+12px)] right-0 w-72 origin-bottom-right animate-[fadeIn_0.2s_ease-out] overflow-hidden rounded-2xl bg-white shadow-[0_24px_60px_-15px_rgba(12,34,48,0.45)] ring-1 ring-black/5"
        >
          <div className="bg-gradient-to-br from-[#0C2230] to-[#0E9A57] px-5 py-4 text-white">
            <p className="font-[Fraunces] text-lg font-medium leading-tight">{L.title}</p>
            <p className="mt-1 text-xs text-white/80">{L.sub}</p>
          </div>
          <ul className="p-2">
            {channels.map((c) => {
              const Icon = c.icon;
              const isDisabled = !c.enabled;
              const content = (
                <span className="flex w-full items-center gap-3">
                  <span
                    className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-white"
                    style={{ backgroundColor: c.color, opacity: isDisabled ? 0.45 : 1 }}
                  >
                    <Icon className="h-5 w-5" />
                  </span>
                  <span className="flex-1 text-left">
                    <span className={`block text-sm font-semibold ${isDisabled ? "text-[#0C2230]/45" : "text-[#0C2230]"}`}>
                      {c.label}
                    </span>
                    {isDisabled && (
                      <span className="block text-[10px] uppercase tracking-wider text-[#0C2230]/40">{L.soon}</span>
                    )}
                    {c.key === "wc" && wechatCopied && (
                      <span className="block text-[10px] font-semibold text-[#0E9A57]">{L.copied}</span>
                    )}
                  </span>
                </span>
              );
              if (isDisabled) {
                return (
                  <li key={c.key}>
                    <div
                      data-testid={`floating-chat-${c.key}`}
                      className="flex w-full cursor-not-allowed items-center rounded-xl px-3 py-2.5"
                    >
                      {content}
                    </div>
                  </li>
                );
              }
              return (
                <li key={c.key}>
                  <a
                    href={c.href}
                    target={c.key === "wc" ? undefined : "_blank"}
                    rel="noreferrer"
                    onClick={c.onClick}
                    data-testid={`floating-chat-${c.key}`}
                    className="flex w-full items-center rounded-xl px-3 py-2.5 transition-colors hover:bg-[#FBFAF6]"
                  >
                    {content}
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
      )}

      {/* Main floating button */}
      <button
        type="button"
        data-testid="floating-chat-toggle"
        aria-label="Chat"
        onClick={() => setOpen((v) => !v)}
        className="group relative inline-flex h-14 w-14 items-center justify-center rounded-full bg-[#0E9A57] text-white shadow-[0_12px_30px_-8px_rgba(14,154,87,0.55)] transition-all hover:scale-110 hover:bg-[#0c8a4d] md:h-16 md:w-16"
      >
        {!open && (
          <span className="absolute inset-0 -z-10 animate-ping rounded-full bg-[#0E9A57] opacity-30" />
        )}
        {open ? (
          <X className="h-6 w-6 md:h-7 md:w-7" />
        ) : (
          <WAIcon className="h-7 w-7 md:h-8 md:w-8" />
        )}
      </button>
    </div>
  );
};

export default FloatingChat;
